var _rect, _rect2, _rect3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconListMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.178955,
    y: 2.35547,
    width: 3.78855,
    height: 3.81208,
    fill: "current"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.178955,
    y: 9.66211,
    width: 3.78855,
    height: 3.81208,
    fill: "current"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.178955,
    y: 16.333,
    width: 3.78855,
    height: 3.81208,
    fill: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1234 1.90723C11.098 1.93715 7.82275 5.03123 7.82275 8.80335C7.82275 10.0591 8.19397 11.2946 8.88627 12.3616C10.7217 15.7778 14.9132 19.9829 14.9551 20.0255C14.9978 20.0682 15.0567 20.0924 15.1188 20.0933C15.1202 20.0933 15.1211 20.0933 15.1225 20.0933C15.1243 20.0933 15.1253 20.0933 15.1271 20.0933C15.1285 20.0933 15.1294 20.0933 15.1308 20.0933C15.1933 20.0924 15.2522 20.0678 15.2945 20.0255C15.3369 19.9829 19.5279 15.7778 21.355 12.3766C22.0561 11.2946 22.4273 10.0587 22.4273 8.80335C22.4278 5.03123 19.1526 1.93715 15.1234 1.90723ZM15.1253 11.1111C13.6569 11.1111 12.4669 9.97287 12.4669 8.56839C12.4669 7.16391 13.6569 6.02563 15.1253 6.02563C16.5936 6.02563 17.7836 7.16391 17.7836 8.56839C17.7836 9.97287 16.5936 11.1111 15.1253 11.1111Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListMap);
export default __webpack_public_path__ + "static/media/icon-list-map.b49962a0.svg";
export { ForwardRef as ReactComponent };